export { default as SkeletonTable } from './SkeletonTable';
